import Box from "@mui/material/Box";
import { styled, keyframes } from "@mui/system";
import { memo } from "react";

const waveAnimation = keyframes`
	0%, 60%, 100% { transform: translateY(0); }
	30% { transform: translateY(-6px); }
`;

const StyledDot = styled("div")(({ size = 6, color = "theme-primary" }) => ({
	width: size,
	height: size,
	backgroundColor: "var(--" + color + ")",
	borderRadius: "50%",
	animation: `${waveAnimation} 1.3s linear infinite`,
	"&:nth-of-type(2)": { animationDelay: "-1.1s" },
	"&:nth-of-type(3)": { animationDelay: "-0.9s" },
}));

const Loading = memo(({ color = "theme-primary", size = "medium" }) => (
	<Box display="flex" minHeight={100} sx={{ marginTop: "6px" }}>
		<Box display="flex" gap={0.5}>
			{[...Array(3)].map((_, i) => (
				<StyledDot key={i} size={size === "small" ? 4 : size === "large" ? 8 : 6} color={color} />
			))}
		</Box>
	</Box>
));

Loading.displayName = "Loading";

export default Loading;
